module.exports = __webpack_public_path__ + "static/media/map.2777114b.png";